import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const MuiListSubheader = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.primary,
      fontSize: capitalDesignTokens.foundations.typography.fontSize.h5,
      fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
      lineHeight: capitalDesignTokens.foundations.typography.lineHeight.h5,
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5)
    })
  }
};
export {
  MuiListSubheader
};
//# sourceMappingURL=MuiListSubheader.js.map
